import axios from 'axios'

export function initPlayer(){
  return (dispatch) => {
    return dispatch({
      type:'GET_INIT_PLAYER',
      payload:axios.get('init')
    })
  }
}

export function getTrackSize(id){
  return (dispatch) => {
    return dispatch({
      type:'GET_TRACK_SIZE',
      payload:axios.get(`filesize/standard/${id}`)
    })
  }
}

export function downloadComplete(id){
  return (dispatch) => {
    return dispatch({
      type:'DOWNLOAD_COMPLETE',
      payload:id
    })
  }
}

export function getTrackSource(){
  return (dispatch) => {
    return dispatch({
      type:'GET_TRACK_SRC',
      payload:axios.get()
    })
  }
}

export function getTrackFile(){
  return (dispatch) => {
    return dispatch({
      type:'GET_TRACK_FILE',
      payload:axios.get()
    })
  }
}

export function logTrack(){
  return (dispatch) => {
    return dispatch({
      type:'POST_LOG_TRACK',
      payload:axios.post()
    })
  }
}

export function recordClassStart(){
  return (dispatch) => {
    return dispatch({
      type:'POST_CLASS_START',
      payload:axios.post()
    })
  }
}

export function currTrack(track){
  return (dispatch) => {
    return dispatch({
      type:'CURR_TRACK',
      payload:track
    })
  }
}

export function setClass(classData,classTypes){
  return (dispatch) => {
    return dispatch({
      type:'START_CLASS',
      payload:{
        classData:classData,
        classTypes:classTypes
      }
    })
  }
}
export function setTracks(data){
  return (dispatch) => {
    return dispatch({
      type:'SET_TRACKS',
      payload:data
    })
  }
}
export function classStarted(){
  return (dispatch) => {
    return dispatch({
      type:'CLASS_STARTED',
      payload:null
    })
  }
}
export function currPlaylist(playlist){
  return (dispatch) => {
    return dispatch({
      type:'CURR_PLAYLIST',
      payload:playlist
    })
  }
}
export function currClassTime(time){
  return (dispatch) => {
    return dispatch({
      type:'CURR_CLASS_TIME',
      payload:time
    })
  }
}
export function currSectionTime(time){
  return (dispatch) => {
    return dispatch({
      type:'CURR_SECTION_TIME',
      payload:time
    })
  }
}
export function totalSectionTime(time){
  return (dispatch) => {
    return dispatch({
      type:'TOTAL_SECTION_TIME',
      payload:time
    })
  }
}
export function totalClassTime(time){
  return (dispatch) => {
    return dispatch({
      type:'TOTAL_CLASS_TIME',
      payload:time
    })
  }
}
export function startPtp(playlist){
  return (dispatch) => {
    return dispatch({
      type:'START_PTP',
      payload:playlist
    })
  }
}
export function setTrackArrBuffer(trackArrBuffer){
  return (dispatch) => {
    return dispatch({
      type:'SET_TRACK_ARR_BUFFER',
      payload:trackArrBuffer
    })
  }
}
export function setCurrTrackPos(pos){
  return (dispatch) => {
    return dispatch({
      type:'SET_CURR_TRACK_POS',
      payload:pos
    })
  }
}
export function setCurrTrackLength(pos){
  return (dispatch) => {
    return dispatch({
      type:'SET_CURR_TRACK_LENGTH',
      payload:pos
    })
  }
}
export function setPlaylistOrder(order){
  return (dispatch) => {
    return dispatch({
      type:'SET_PLAYLIST_ORDER',
      payload:order
    })
  }
}
export function selectTrack(trackIndex){
  return (dispatch) => {
    return dispatch({
      type:'SELECT_TRACK',
      payload:trackIndex
    })
  }
}
export function skipForward(){
  return (dispatch) => {
    return dispatch({
      type:'SKIP_FORWARD',
      payload:null
    })
  }
}
export function skipBack(){
  return (dispatch) => {
    return dispatch({
      type:'SKIP_BACK',
      payload:null
    })
  }
}


// WEBPACK FOOTER //
// ./src/store/actions/playerAction.js